import React, { useState } from "react";
import api from "../api/client";
import { exportFile } from "../utils/exportFile";
import config, { REPORT_EXPORT_MAP } from "../config";


export default function AcceptedReport() {
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [tableData, setTableData] = useState([]);
  const [exportType, setExportType] = useState("");
  const [loading, setLoading] = useState(false);

  /* -----------------------------------------------------
        FETCH ACCEPTED SHIPMENTS REPORT
  ------------------------------------------------------ */
  const handleSearch = async () => {
    if (!dateFrom || !dateTo) {
      alert("Please select both dates");
      return;
    }

    setLoading(true);
    try {
          const res = await api.get("/api/reports/accepted", {
            params: { dateFrom, dateTo },
          });


      setTableData(res.data?.data || []);
    } catch (err) {
      console.error(err);
      alert("Failed to fetch accepted shipments");
    } finally {
      setLoading(false);
    }
  };

  /* -----------------------------------------------------
        EXPORT HANDLER
  ------------------------------------------------------ */
  const handleExport = async () => {
    if (!exportType) {
      alert("Please select an export format");
      return;
    }

    if (!dateFrom || !dateTo) {
      alert("Please select date range before export");
      return;
    }

    try {
      const type = exportType.toLowerCase();

      await exportFile(
        REPORT_EXPORT_MAP.accepted[type],
        { from: dateFrom, to: dateTo },
        `Accepted_Report.${type === "excel" ? "xlsx" : type}`
      );
    } catch (err) {
      console.error(err);
      alert("Export failed");
    }
  };
return (


    <div style={styles.page}>

      {/* HEADER */}
      <div style={styles.header}>
        <h2 style={styles.title}>Accepted Shipments Report</h2>
        <p style={styles.subtitle}>
          Review accepted shipment data within a selected date range
        </p>
      </div>

      {/* FILTERS */}
      <div style={styles.card}>
        <div style={styles.grid}>
          <div>
            <label style={styles.label}>Date From</label>
            <input
              type="date"
              style={styles.input}
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </div>

          <div>
            <label style={styles.label}>Date To</label>
            <input
              type="date"
              style={styles.input}
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </div>

          <div style={{ alignSelf: "end" }}>
            <button style={styles.searchBtn} onClick={handleSearch}>
              {loading ? "Searching..." : "Search"}
            </button>
          </div>
        </div>

        {/* EXPORT */}
        <div style={styles.exportRow}>
          <select
            style={styles.input}
            value={exportType}
            onChange={(e) => setExportType(e.target.value)}
          >
            <option value="">Export Format</option>
            <option value="CSV">CSV</option>
            <option value="EXCEL">Excel</option>
            <option value="PPT">PowerPoint</option>

          </select>

          <button style={styles.exportBtn} onClick={handleExport}>
            Export Report
          </button>
        </div>
      </div>

      {/* TABLE */}
    <div style={styles.card}>
      <h3 style={styles.sectionTitle}>Accepted Shipments</h3>

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ASN Number</th>
              <th style={styles.th}>SKU</th>
              <th style={styles.th}>Shipper Name</th>
              <th style={styles.th}>Accepted Date</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" style={styles.emptyCell}>
                  Loading data...
                </td>
              </tr>
            ) : tableData.length === 0 ? (
              <tr>
                <td colSpan="4" style={styles.emptyCell}>
                  No accepted shipments found
                </td>
              </tr>
            ) : (
              tableData.map((row, i) => (
                <tr
                  key={i}
                  style={i % 2 === 0 ? styles.rowEven : styles.rowOdd}
                >
                  <td style={styles.td}>{row.ASN}</td>
                  <td style={styles.td}>{row.SKU}</td>
                  <td style={styles.td}>{row.ShipperName}</td>
                  <td style={styles.td}>{row.AcceptedDate}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>


    </div>
  );
}

/* ----------------------------
      PROFESSIONAL STYLES
----------------------------- */
const styles = {
  page: {
    padding: "2rem",
    background: "#f5f7fb",
    minHeight: "100vh",
    fontFamily: "Inter, Arial, sans-serif",
  },
  header: {
    textAlign: "center",
    marginBottom: "1.5rem",
  },
  title: {
    margin: 0,
    fontSize: "2rem",
    fontWeight: 700,
    color: "#1f2937",
  },
  subtitle: {
    marginTop: "0.4rem",
    color: "#6b7280",
  },
  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "1.5rem",
    boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
    maxWidth: "1100px",
    margin: "0 auto 1.5rem",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 200px",
    gap: "1rem",
  },
  label: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#374151",
  },
  input: {
    width: "100%",
    padding: "0.7rem",
    marginTop: "0.3rem",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    fontSize: "0.95rem",
  },
  searchBtn: {
    width: "80%",
    padding: "0.8rem",
    background: "#696a6dff",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontWeight: 600,
    cursor: "pointer",
  },
  exportRow: {
    display: "flex",
    gap: "1rem",
    marginTop: "1.5rem",
  },
  exportBtn: {
    padding: "0.8rem 1.5rem",
    background: "#dc2626",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontWeight: 600,
    cursor: "pointer",
  },
  sectionTitle: {
    marginBottom: "1rem",
    fontWeight: 600,
    color: "#374151",
  },
  tableWrapper: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  emptyCell: {
    padding: "1.2rem",
    textAlign: "center",
    color: "#6b7280",
  },

  th: {
  padding: "12px",
  background: "#f3f4f6",
  color: "#1f2937",
  fontSize: "0.9rem",
  fontWeight: 700,
  textAlign: "left",
  borderBottom: "2px solid #d1d5db",
  whiteSpace: "nowrap",
},

td: {
  padding: "11px 12px",
  fontSize: "0.9rem",
  color: "#374151",
  borderBottom: "1px solid #e5e7eb",
},

rowEven: {
  background: "#ffffff",
},

rowOdd: {
  background: "#f9fafb",
},

};
